export class EventCreationDto {
  type: string;
  success: boolean;
  source: string = "MatrixNutri"

  constructor(type: string, success:boolean) {
    this.type = type;
    this.success = success;
  }
}
